module.exports = __webpack_public_path__ + "static/media/NG.5d22ff07.svg";